module.exports = __webpack_public_path__ + "static/media/decor-scop-work.83268307.png";